export const enum SuggestAction {
  PIN_DROP = 'pin_drop',
  SEARCH = 'search',
  USER_INPUT = 'user_input',
  USER_SELECT = 'user_select',
  ZERO_SUGGEST = 'zero_suggest',
  FINALIZE = 'finalize',
  REDIRECT = 'redirect',
  GEO_MAGNET = 'geomagnet',
}
